export enum AdvertiserStatus {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  PENDING = 'PENDING',
  ARCHIVED = 'ARCHIVED',
}

export interface RawAdvertiserApiResponse {
  project_id: string;
  company_name: string;
  id: string;
  advertiser_key: string | null;
  contact_info: ContactInfo | null;
  address_line1: string;
  address_line2: string;
  postal_code: string;
  city: string;
  state: string;
  country: string;
  vat_number: string;
  billing_contact: string;
  billing_email: string;
  custom: any;
  status: AdvertiserStatus;
  created_at: string;
  updated_at: string;
  retailer_tags?: string[] | null;
  budget_monthly_cents?: number | null;
  budget_total_cents?: number | null;
  budget_total_left_cents?: number | null;
  budget_total_left_percent?: number | null;
}

export interface ContactInfo {
  email: string | null;
  last_name: string | null;
  first_name: string | null;
}

export interface RawAdvertiserUpdateStatusRequest {
  status: AdvertiserStatus;
}

export interface FlatUpdateAdvertiserRequest {
  company_name: string;
  advertiser_key: string | null;
  email: string;
  last_name: string;
  first_name: string;
  address_line1: string;
  address_line2: string;
  postal_code: string;
  city: string;
  state: string;
  country: string;
  vat_number: string;
  billing_contact: string;
  billing_email: string;
  custom: any;
  retailer_tags?: string[] | null;
}

export interface UpdateAdvertiserRequest {
  company_name: string;
  advertiser_key: string | null;
  contact_info: ContactInfo | null;
  address_line1: string;
  address_line2: string;
  postal_code: string;
  city: string;
  state: string;
  country: string;
  vat_number: string;
  billing_contact: string;
  billing_email: string;
  custom: any;
  retailer_tags?: string[] | null;
}

export interface PatchAdvertiserRequest {
  advertiser_key?: string | null;
  retailer_tags?: Array<string> | null;
  company_name?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  postal_code?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  vat_number?: string | null;
  billing_contact?: string | null;
  billing_email?: string | null;
  contact_info?: ContactInfoUpdate | null;
  custom?: any;
}

export interface ContactInfoUpdate {
  email?: string | null;
  first_name?: string | null;
  last_name?: string | null;
}

export interface CreateApprovedAdvertiserRequest {
  company_name: string;
  contact_info?: ContactInfo | null;
}

export interface SignUpAdvertiserRequest {
  project_key: string;
  company_name: string;
  email: string;
  last_name: string;
  first_name: string;
  address_line1: string;
  address_line2: string;
  postal_code: string;
  city: string;
  state: string;
  country: string;
  vat_number: string;
  billing_contact: string;
  billing_email: string;
  advertiser_key: string | null;
  terms: boolean;
}

export function rawAdvertiserApiResponseToRawAdvertiserApiUpdateRequest(
  data: RawAdvertiserApiResponse | UpdateAdvertiserRequest,
): UpdateAdvertiserRequest {
  return {
    company_name: data.company_name,
    advertiser_key: data.advertiser_key || null,
    contact_info: data.contact_info || null,
    address_line1: data.address_line1 || '',
    address_line2: data.address_line2 || '',
    postal_code: data.postal_code || '',
    city: data.city || '',
    state: data.state || '',
    country: data.country || '',
    vat_number: data.vat_number || '',
    billing_contact: data.billing_contact || '',
    billing_email: data.billing_email || '',
    custom: data.custom,
    retailer_tags: data.retailer_tags || null,
  };
}
